(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-supply-triptych-hero"] && !Shopify.designMode) return;
  try {
    
function initialiseBaseSupplyWalkingVideo(root) {
  root.querySelectorAll('[data-base-walking-video]').forEach((media) => {
    if (media.dataset.videoInitialised) return;
    media.dataset.videoInitialised = 'true';
    const video = media.querySelector('video');
    const source = video.querySelector('source[data-src]');
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const showPhoto = () => media.classList.remove('has-video');
    video.addEventListener('playing', () => media.classList.add('has-video'));
    video.addEventListener('error', showPhoto);
    const applyPreference = () => {
      if (preference.matches) {
        video.pause();
        source.removeAttribute('src');
        video.load();
        showPhoto();
        return;
      }
      source.src = source.dataset.src;
      video.muted = true;
      video.load();
      video.play().catch(showPhoto);
    };
    preference.addEventListener('change', applyPreference);
    applyPreference();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseBaseSupplyWalkingVideo(document), { once: true });
} else {
  initialiseBaseSupplyWalkingVideo(document);
}
document.addEventListener('shopify:section:load', (event) => initialiseBaseSupplyWalkingVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
